import { render, staticRenderFns } from "./accountCheckManage.vue?vue&type=template&id=c3132702&scoped=true"
import script from "./accountCheckManage.vue?vue&type=script&lang=js"
export * from "./accountCheckManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3132702",
  null
  
)

export default component.exports